<nav id="secao-top-nav" class="pt-2 pb-2">
  <div class="container flex justify-content-center">
    <div class="row">
      <div class="col-md-2">
        <a routerLink="/">
          <img src="assets/imagens/logo-branca.png" class="logo-fundacao" />
        </a>
      </div>
      <div class="col-md-7 opcoes-menu d-flex align-items-center">
        <div class="w-100 d-flex justify-content-end align-items-center">
          <a class="menu" [routerLinkActive]="['ativa']" routerLink="/sobre"
            >Sobre</a
          >
          <a class="menu" [routerLinkActive]="['ativa']" routerLink="/contato"
            >Contato</a
          >
          <a class="menu login-button" href="https://blog.educere.org.br" target="_blank">Blog</a>
          <a class="menu login-button" href="https://app.educere.org.br" target="_blank">Login</a>
        </div>
      </div>
    </div>
  </div>
</nav>
